import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const PerformancePlanningIcon = {
  name: 'PerformancePlanningIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || (s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x');
      }
    },
    // Merged into a single 'gradient' prop
    gradient: {
      type: Array,
      default: () => ['#FFFFFF', '#FFFFFF'], // Default to white for both stop colors
      validator: function (arr) {
        // Ensure it's an array with exactly two string elements
        return arr.length === 2 && typeof arr[0] === 'string' && typeof arr[1] === 'string';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x'
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;

    // Destructure the single 'gradient' prop into its start and end colors
    const [gradientStartColor, gradientEndColor] = ctx.props.gradient;

    // Generate unique IDs for the linear gradients to prevent conflicts if multiple icons are on the page
    const uniqueIdSuffix = Math.random().toString(36).substring(2, 9);
    const gradientId0 = `paint0_linear_3168_50426_${uniqueIdSuffix}`;
    const gradientId1 = `paint1_linear_3168_50426_${uniqueIdSuffix}`;

    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "38",
        height: "35",
        viewBox: "-5 3 45 30",
        fill: "none",
        "stroke-width": "0px" // This was already here, keeping it.
      },
      "class": "feather feather-performance-planning"
    }, ctx.data]), [
      h("defs", {}, [
        // First linear gradient definition
        h("linearGradient", {
          attrs: {
            id: gradientId0,
            x1: "18.5268",
            y1: "3.4613",
            x2: "18.5268",
            y2: "34.2807",
            gradientUnits: "userSpaceOnUse"
          }
        }, [
          h("stop", { attrs: { "stop-color": gradientStartColor } }),
          h("stop", { attrs: { offset: "1", "stop-color": gradientEndColor } })
        ]),
        // Second linear gradient definition
        h("linearGradient", {
          attrs: {
            id: gradientId1,
            x1: "17.619",
            y1: "13.6841",
            x2: "17.619",
            y2: "25.834",
            gradientUnits: "userSpaceOnUse"
          }
        }, [
          h("stop", { attrs: { "stop-color": gradientStartColor } }),
          h("stop", { attrs: { offset: "1", "stop-color": gradientEndColor } })
        ])
      ]),
      h("path", {
        attrs: {
          d: "M37.3735 5.33104C36.7809 5.49773 35.7807 5.88667 34.8176 6.72013C33.4656 7.90549 32.9655 9.29459 32.7803 9.90579C32.6877 9.40571 32.3358 7.9981 31.0763 6.81274C29.9465 5.7385 28.7056 5.42364 28.187 5.31251C28.7241 5.18286 29.9836 4.81244 31.1134 3.68264C32.2617 2.53432 32.6506 1.25636 32.7803 0.719238C32.947 1.31192 33.373 2.40467 34.3361 3.44187C35.4844 4.64575 36.7624 5.1273 37.355 5.31251L37.3735 5.33104Z",
          fill: gradientStartColor // Fill now uses the gradient's start color
        }
      }),
      h("path", {
        attrs: {
          d: "M36.4276 12.4441V34.2807H0.625977V3.4613H23.4998",
          stroke: `url(#${gradientId0})`, // Stroke uses the first gradient
          "stroke-width": "0.75",
          "stroke-linecap": "round",
          "stroke-linejoin": "bevel"
        }
      }),
      h("path", {
        attrs: {
          d: "M6.18213 25.834L14.387 15.8696L20.8139 23.6856L29.0559 13.6841",
          stroke: `url(#${gradientId1})`, // Stroke uses the second gradient
          "stroke-miterlimit": "10",
          "stroke-width": "0.75"
        }
      })
    ]);
  }
};

export default PerformancePlanningIcon;